import { init } from "./flower_nav.mjs";

init();
